import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, X, ArrowRight } from "lucide-react";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function FloatingCTA() {
  const navigate = useNavigate();
  const [cbOpen, setCbOpen] = useState(false);
  const [form, setForm] = useState({ name: "", phone: "", preferred_time: "" });
  const [loading, setLoading] = useState(false);

  const submitCallback = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/callbacks", form);
      toast.success("Callback requested. An adviser will call you shortly.");
      setForm({ name: "", phone: "", preferred_time: "" });
      setCbOpen(false);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Something went wrong. Please try again.");
    } finally { setLoading(false); }
  };

  return (
    <>
      {/* Persistent Get Funding pill */}
      <button
        data-testid="floating-get-funding-btn"
        onClick={() => navigate("/contact?src=floating-cta")}
        className="fixed bottom-6 left-1/2 -translate-x-1/2 z-40 lg:hidden bg-lime text-[#1A1A1A] font-bold px-8 py-4 flex items-center gap-2 glow-lime"
      >
        Get Funding <ArrowRight className="w-4 h-4" />
      </button>

      {/* Side action buttons */}
      <div className="fixed bottom-6 right-6 z-40 flex flex-col items-end gap-3">
        <button data-testid="callback-toggle-btn" onClick={() => setCbOpen(true)} className="w-14 h-14 bg-lime text-[#1A1A1A] flex items-center justify-center hover:glow-lime-strong transition-shadow" title="Request a callback">
          <Phone className="w-6 h-6" />
        </button>
      </div>

      {/* Callback modal */}
      <AnimatePresence>
        {cbOpen && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-6" onClick={() => setCbOpen(false)}>
            <motion.div initial={{ y: 30, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 30, opacity: 0 }} onClick={(e) => e.stopPropagation()} className="bg-[#1A1A1A] border border-[#808080]/30 w-full max-w-md p-8" data-testid="callback-modal">
              <div className="flex justify-between items-start mb-6">
                <div>
                  <h3 className="text-2xl font-bold">Request a callback</h3>
                  <p className="text-grey text-sm mt-1">An adviser will call you back, fast.</p>
                </div>
                <button onClick={() => setCbOpen(false)} data-testid="callback-close-btn"><X className="w-6 h-6 text-grey hover:text-white" /></button>
              </div>
              <form onSubmit={submitCallback} className="space-y-4">
                <input required data-testid="callback-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Your name" className="w-full bg-[#111] border border-[#808080]/30 px-4 py-3 text-white outline-none focus:border-lime" />
                <input required data-testid="callback-phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="Phone number" className="w-full bg-[#111] border border-[#808080]/30 px-4 py-3 text-white outline-none focus:border-lime" />
                <input data-testid="callback-time" value={form.preferred_time} onChange={(e) => setForm({ ...form, preferred_time: e.target.value })} placeholder="Preferred time (optional)" className="w-full bg-[#111] border border-[#808080]/30 px-4 py-3 text-white outline-none focus:border-lime" />
                <button disabled={loading} data-testid="callback-submit" className="w-full bg-lime text-[#1A1A1A] font-bold py-4 hover:glow-lime transition-shadow">{loading ? "Sending..." : "Request Callback"}</button>
              </form>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
